
export const downloadCSV = (content: string, fileName: string, mimeType = 'text/csv;charset=utf-8;') => {
    const a = document.createElement('a');
    mimeType = mimeType || 'application/octet-stream';
    const navigatorWithSave = navigator as Navigator & {
        msSaveBlob?: (blob: Blob, fileName: string) => void,
    };

    if (typeof navigatorWithSave.msSaveBlob === 'function') { // IE10
        navigatorWithSave.msSaveBlob(new Blob([content], {
            type: mimeType,
        }), fileName);
    } else if (URL && 'download' in a) { // html5 A[download]
        a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType,
        }));
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } else {
        location.href = 'data:application/octet-stream,' + encodeURIComponent(content);
    }
};
